import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { TargetSelector, combinedSettingsSelector, getSettingSelector, makeTextStyleSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import { connect } from "react-redux";
import Component, { type MapProps } from "./component";
import { makeButtonStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector();
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["placement", "visibility"], "label");
  const labelStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "label");
  const primaryButtonStyleSelector = makeButtonStyleSelector(TargetSelector.Entity, "button");
  const primaryButtonInnerHorizontalAlign = getSettingSelector(TargetSelector.Entity, "innerHorizontalAlign", "button");
  const secondaryButtonStyleSelector = makeButtonStyleSelector(TargetSelector.Entity, "secondaryButton");
  const secondaryButtonPropSelector = getSettingSelector(TargetSelector.Entity, "secondaryButton");

  return (state: AppState, props: WithChildren & EntityRef): MapProps => {
    const { placement, visibility } = settingsSelector(state, props);

    // NOTE: we assume that label, field and primary button settings always exist. secondaryButton is optional
    const secondaryButtonProp = secondaryButtonPropSelector(state, props);
    return {
      ...props,
      buttonsAlign: primaryButtonInnerHorizontalAlign(state, props),
      fieldStyle: fieldStyleSelector(state, props),
      labelPlacement: placement,
      labelVisibility: visibility,
      labelStyle: labelStyleSelector(state, props),
      primaryButtonStyle: primaryButtonStyleSelector(state, props as any),
      // NOTE: couldn't figure out how to do nicely
      secondaryButtonStyle: secondaryButtonProp ? secondaryButtonStyleSelector(state, props as any) : undefined
    };
  };
};

const FormStyleProvider = connect(makeMapStateToProps)(Component);
export default FormStyleProvider;
